import { css } from 'twin.macro';
import React, { useState, useRef } from 'react';
import { FacebookSelector } from '@charkour/react-reactions';
import { useOutsideClickListener } from '../../../../_helpers/hooks/useOutsideClickListener';
import { HiOutlineEmojiHappy } from 'react-icons/hi';
import { fetchWrapper } from '@/_helpers';
import { promoteMyReaction } from '../utils/reactionCounter';

const MessageReactionSelector = ({
    m = {},
    rId,
    subChannelId,
    currUser,
    reactionCounter,
    setReactionCounter,
    isSenderMessage = false,
}) => {
    const { id } = m;
    const [showReactions, setShowReactions] = useState(false);
    const emojiWrapperRef = useRef(null);
    useOutsideClickListener(emojiWrapperRef, () => {
        setShowReactions(false);
    });
    const handleReaction = async (emoji) => {
        setShowReactions(false);

        // setting the reaction counter
        let myReactionIndex = reactionCounter.findIndex((reaction) => reaction?.by === currUser.name);
        if (subChannelId) {
            if (myReactionIndex >= 0) {
                if (reactionCounter[myReactionIndex].emoji === emoji) {
                    // remove reaction
                    let newReactionCounter = [...reactionCounter];
                    newReactionCounter.splice(myReactionIndex, 1);
                    setReactionCounter(newReactionCounter);
                    await fetchWrapper.put(`subchannels/${subChannelId}/${id}/reactions?remove=true`, {
                        reaction: emoji,
                    });
                } else {
                    let newReactionCounter = [...reactionCounter];
                    newReactionCounter.splice(myReactionIndex, 1);
                    setReactionCounter(promoteMyReaction(newReactionCounter, emoji, currUser.name));
                    await fetchWrapper.put(`subchannels/${subChannelId}/${id}/reactions`, { reaction: emoji });
                }
            } else {
                setReactionCounter(promoteMyReaction(reactionCounter, emoji, currUser.name));
                await fetchWrapper.put(`subchannels/${subChannelId}/${id}/reactions`, { reaction: emoji });
            }
        } else {
            if (myReactionIndex >= 0) {
                if (reactionCounter[myReactionIndex].emoji === emoji) {
                    // remove reaction
                    let newReactionCounter = [...reactionCounter];
                    newReactionCounter.splice(myReactionIndex, 1);
                    setReactionCounter(newReactionCounter);
                    await fetchWrapper.put(`chatrooms/${rId}/${id}/reactions?remove=true`, { reaction: emoji });
                } else {
                    let newReactionCounter = [...reactionCounter];
                    newReactionCounter.splice(myReactionIndex, 1);
                    setReactionCounter(promoteMyReaction(newReactionCounter, emoji, currUser.name));
                    await fetchWrapper.put(`chatrooms/${rId}/${id}/reactions`, { reaction: emoji });
                }
            } else {
                setReactionCounter(promoteMyReaction(reactionCounter, emoji, currUser.name));
                await fetchWrapper.put(`chatrooms/${rId}/${id}/reactions`, { reaction: emoji });
            }
        }
    };
    return (
        <div
            css={css`
                position: relative;
                &.show {
                    visibility: visible !important;
                    opacity: 1;
                }
                ${isSenderMessage ? 'padding-left: 0.5rem;' : ''}
            `}
            className={`dropper ${showReactions ? 'show' : ''}`}
        >
            <div
                css={css`
                    position: relative;
                `}
            >
                <div ref={emojiWrapperRef}>
                    <HiOutlineEmojiHappy color="#50aeb0" size={30} onClick={() => setShowReactions(!showReactions)} />
                    {showReactions ? (
                        <div
                            css={css`
                                position: absolute;
                                z-index: 99999;
                                top: -265%;
                                ${isSenderMessage ? 'right: 0;' : 'left:0;'}
                            `}
                        >
                            <FacebookSelector onSelect={handleReaction} />
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default MessageReactionSelector;
